<template>
    <v-container>
        <form-toolbar :canEdit="canEdit" :userRoles="userRoles" :editMode="editMode"  :field="'activation'" :assignment="assignment" @cancel-button-clicked="switchEditMode(false)" @edit-button-clicked="switchEditMode(true)"/>
        <v-form :readonly="readOnly" class="assignment-form">
            <v-card class = "form-group-fields" elevation="6">
                <div class = "first-row">
                    <custom-datetime :value="localActivation.appointmentDate || ''" :readOnly="true" @onSelect="appointmentDateSelected"/>
                    <v-select
                        v-model="localActivation.status"
                        :items="statuses"
                        item-value="value"
                        item-text="name"
                        label="Κατάσταση"
                        outlined
                        class="field status"
                    ></v-select>
                    <v-dialog
                        v-if="this.assignment?.autopsy?.floorStructure"
                        v-model="dialog"
                        width="500"
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                v-bind="attrs"
                                v-on="on"
                                class="white--text"
                                large
                                :color="'black'"
                                :depressed="editMode">
                                Δομη Κτιριου
                            </v-btn>
                        </template>
                        <floor-structure :editMode="false" :stored="this.assignment.autopsy.floorStructure" />
                    </v-dialog>
                </div>
                <div class="text-area-wrapper">
                    <comments
                        ref="comments"
                        :comments="this.localActivation?.comments || {}"
                        :clearable="clearable"
                        :editMode="editMode"
                        :rules="editMode ? rules: []"
                        @new-comment="onNewComment"
                    />
                </div>
                <material-selection v-if="config.hasStorage" ref="material-selection" class="material-selection" :editMode="editMode" :assignmentTab="'activation'" :assignment="assignment" />
                <v-divider class="mt-5 divider"/>

                <issue-existance-field
                    ref="malfunction-section"
                    :label="'Βλάβη / Πρόβλημα'"
                    :photoLabel="'Φωτογραφίες Βλάβης'"
                    :check="hasMalfunction"
                    :comments="localActivation.malfunction?.comments || {}"
                    :uploadedPhotos="localActivation.malfunction?.photos || []"
                    :readOnly="readOnly"
                    :clearable="clearable"
                    :editMode="editMode"
                    :uploadPath="this.assignment.sr + '/activation/malfunction'"
                    @onIssuePhotoSelection="onTroublePhotoSelection"
                />
            </v-card>
            <div v-if="canEdit" class="submit-button-wrapper">
                <v-btn class="mx-2 white--text" :disabled="shouldDisableSubmit" :loading="loading" large color="black" @click="onSubmit">
                    ΥΠΟΒΟΛΗ
                </v-btn>
            </div>
        </v-form>
        <alert :show-alert="showAlert" :message="message" :type="type" />
    </v-container>
</template>

<script>
    import assignmentService from '@/services/assignment'
    import Alert from '@/components/Alert'
    import FormToolbar from '@/components/FormToolbar'
    import geolocation from '@/utils/geolocation'
    import MaterialSelection from '@/components/MaterialSelection'
    import FloorStructure from '@/components/FloorStructure'
    import IssueExistanceField from '@/components/IssueExistanceField'
    import Comments from '@/components/Comments'
    import momentTimezone from 'moment-timezone'
    import CustomDatetime from '@/components/CustomDatetime'

    export default {
        name: 'ConstructionTab',
        components: { Alert, Comments, CustomDatetime, FormToolbar, MaterialSelection, FloorStructure, IssueExistanceField },
        props: {
            assignment: {
                type: Object,
                required: true
            },
            currentUser: {
                type: Object,
                default: () => { return {} },
                required: true
            },
            canEdit: {
                type: Boolean,
                required: true
            }
        },
        watch: {
            assignment: {
                handler() {
                    this.resetForm()
                },
                deep: true
            }
        },
        computed: {
            userRoles() {
                return this.currentUser?.roles?.map(role => role.role) || []
            },
            shouldDisableSubmit() {
                return !((this.localActivation.status || (this.localActivation.status && this.localActivation.appointmentDate && (this.localActivation.comments || this.newComment))) && this.editMode)
            },
            client() {
                return this.assignment.client.name
            },
            isCompleted() {
                return this.localActivation?.status === 'COMPLETED'
            },
            config() {
                return this.$store.getters.getConfig || {}
            },
            statuses() {
                return this.config?.activation?.statuses || []
            }
        },
        data: () => {
            return {
                localActivation: {
                    completed: false,
                    description: null
                },
                selectedTroublePhotos: 0,
                hasMalfunction: false,
                showAlert: false,
                message: null,
                type: null,
                loading: false,
                mode: null,
                dialog: false,
                readOnly: false,
                newComment: null,
                clearable: true,
                rules: [
                    v => !!v || 'Το πεδίο είναι υποχρεωτικό'
                ],
                editMode: false
            }
        },
        created() {
            this.mode = this.$route.params.mode
            if (this.mode === 'edit') {
                this.readOnly = true
                this.clearable = false
            }
            this.assignmentId = this.$route.params.assignmentId
        },
        mounted() {
            this.resetForm()
        },
        methods: {
            appointmentDateSelected(datetime) {
                this.$set(this.localActivation, 'appointmentDate', momentTimezone(datetime).tz('Europe/Athens').utc().format('YYYY-MM-DD[T]HH:mm:ss[Z]').toString())
            },
            onNewComment(e) {
                this.newComment = e
            },
            onTroublePhotoSelection(noOfSelectedPhotos) {
                this.selectedTroublePhotos = noOfSelectedPhotos
            },
            tabSelect(tab) {
                this.selectedTab = tab
            },
            switchEditMode(editMode) {
                if (!this.canEdit) {
                    return
                }
                this.resetForm()
                if (editMode) {
                    this.readOnly = false
                    this.clearable = true
                    this.editMode = true
                } else {
                    this.readOnly = true
                    this.clearable = false
                    this.editMode = false
                }
            },
            resetForm() {
                this.localActivation = this.assignment.activation ? JSON.parse(JSON.stringify(this.assignment.activation)) : {}
                this.hasMalfunction = !!this.localActivation.malfunction
            },
            setAlert(message, type) {
                this.showAlert = true
                this.message = message
                this.type = type
                setTimeout(() => { this.showAlert = false }, 7000)
            },
            async editAssignment() {
                this.loading = true
                const coords = await geolocation.getCoordinates()
                this.localActivation.geolocation = coords
                const malfunctionSection = this.$refs['malfunction-section'].getIssueValues()
                this.hasMalfunction = malfunctionSection.checked
                if (this.hasMalfunction) {
                    this.localActivation.malfunction = this.localActivation.malfunction || { photos: [] }
                    this.localActivation.malfunction.newComment = malfunctionSection.newComment
                }
                try {
                    if (this.hasMalfunction) {
                        const uploadedTroubleshootingPhotos = await this.$refs['malfunction-section'].uploadPhotos()
                        this.localActivation.malfunction.photos = uploadedTroubleshootingPhotos ? this.localActivation.malfunction.photos.concat(uploadedTroubleshootingPhotos) : [ ...this.localActivation.malfunction.photos ]
                    }
                } catch (error) {
                    this.setAlert(error.message, 'error')
                    this.loading = false
                    return
                }

                this.localActivation.newComment = this.newComment
                if (this.config.hasStorage) {
                    this.localActivation.materialsRequested = this.$refs['material-selection'].proccessMaterialRequested()
                }
                assignmentService.updateAssignmentTab('activation', this.assignment.id, { activation: this.localActivation }).then((response) => {
                    this.loading = false
                    this.switchEditMode(false)
                    this.$refs['comments'].clear()
                    this.$refs['malfunction-section'].clear()
                    this.setAlert('Η ενημέρωση της Ενεργοποίησης ήταν επιτυχημένη', 'success')
                    this.$emit('assignment-refresh')
                }).catch((error) => {
                    this.setAlert(error?.response?.data?.message || 'Προέκυψε κάποιο σφάλμα. Παρακαλώ επικοινωνήστε με τον Διαχειριστή', 'error')
                    this.loading = false
                })
            },
            async onSubmit() {
                if (this.mode === 'edit') {
                    this.editAssignment()
                }
            }
        }

    }
</script>
<style scoped>
.first-row {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    align-items: first baseline;
    justify-content: space-evenly;
    margin-top: 0.8rem;
}

.form-group-fields {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    flex-wrap: wrap;
}

.submit-button-wrapper {
    width: 100%;
    display: flex;
    justify-content: center;
    margin-top: 2vh;
}

.field.completed-checkbox {
    font-weight: 800;
}

input {
    text-align: center !important;
}

.v-card {
    padding: 0.8rem;
    color: var(--cards-and-tables-text-color) !important;
    background: var(--cards-and-tables-color) !important;
}

.field.completed-checkbox {
    font-weight: 800;
}

.text-area-wrapper {
    width: 100%;
}

.material-selection, .divider {
    width: 100%;
}

.field.status {
    min-width: 270px;
    max-width: 20%;
}

.troubleshoot-area {
    width: 100%;
}
</style>
